import { apiClient, unwrap } from './client';
import type {
  ChangePasswordRequest,
  LoginRequest,
  LoginResponse,
  LogoutRequest,
  MeResponse,
  RefreshTokenRequest,
  SelectEnterpriseRequest,
} from '@/types/auth';
import type { ApiResponse } from '@/types/api';

export const authApi = {
  login(request: LoginRequest): Promise<LoginResponse> {
    return unwrap(apiClient.post<ApiResponse<LoginResponse>>('/auth/login', request));
  },

  selectEnterprise(request: SelectEnterpriseRequest): Promise<LoginResponse> {
    return unwrap(
      apiClient.post<ApiResponse<LoginResponse>>('/auth/select-enterprise', request),
    );
  },

  refresh(request: RefreshTokenRequest): Promise<LoginResponse> {
    return unwrap(apiClient.post<ApiResponse<LoginResponse>>('/auth/refresh', request));
  },

  logout(request: LogoutRequest): Promise<void> {
    return apiClient.post('/auth/logout', request).then(() => undefined);
  },

  changePassword(request: ChangePasswordRequest): Promise<void> {
    return apiClient.post('/auth/change-password', request).then(() => undefined);
  },

  me(): Promise<MeResponse> {
    return unwrap(apiClient.get<ApiResponse<MeResponse>>('/auth/me'));
  },
};
